<script setup lang="ts">
type Props = {
  title: string;
  message?: string[] | string;
};

const { message } = defineProps<Props>();

type Slots = {
  action?(): HTMLElement;
  default?(): HTMLElement;
};

defineSlots<Slots>();

const errorMessages = computed(() => {
  if (!message) return;

  return Array.isArray(message) ? message : [message];
});
</script>

<template>
  <div class="browser-viewport-span">
    <div
      class="h-screen w-96 max-w-full mx-auto text-center flex flex-col items-center px-4 justify-center"
    >
      <h1 class="text-3xl font-normal uppercase">
        {{ title }}
      </h1>
      <div
        v-if="errorMessages"
        class="mt-2"
      >
        <p
          v-for="errorMessage in errorMessages"
          :key="errorMessage"
          class="text-platform-text-2"
        >
          {{ errorMessage }}
        </p>
      </div>
      <div
        v-if="$slots.action"
        class="mt-6"
      >
        <slot name="action" />
      </div>
      <slot name="default" />
    </div>
  </div>
</template>
